import {
  getAbility,
  getAgreement,
  getProducts,
  getRequests,
  getProductsType,
  getRut,
  postCreateRequest,
  downloadRequests,
  getAgreementConfig,
  getActiveOffer
} from '../../services/agreementAdjustment'
import { makeActionCreator } from '../../config/store/utils'
import { customizeError } from '@chilecompra/react-kit'
import { batch } from 'react-redux'

export const GET_ABILITY_CONFIG = 'GET_ABILITY_CONFIG'
export const GET_ABILITY_CONFIG_ERROR = 'GET_ABILITY_CONFIG_ERROR'
export const GET_ABILITY_CONFIG_SUCCESS = 'GET_ABILITY_CONFIG_SUCCESS'
export const onGetAbilityConfig = makeActionCreator(GET_ABILITY_CONFIG)
export const onGetAbilityConfigError = makeActionCreator(false, 'payload')
export const onGetAbilityConfigSuccess = makeActionCreator(GET_ABILITY_CONFIG_SUCCESS, 'payload')
export const onGetAbilityConfigThunk =
  ({ callback, payload }) =>
  async dispatch => {
    dispatch(onGetAbilityConfig({ providerId: payload.providerId, convenioId: payload.convenioId }))
    try {
      const { data } = await getAbility({ providerId: payload.providerId, convenioId: payload.convenioId })
      dispatch(
        onGetAbilityConfigSuccess({
          data
        })
      )
      callback(data)
    } catch (error) {
      callback(error)
      return dispatch(onGetAbilityConfigError(true, error))
    }
  }

export const GET_AGREEMENT = 'GET_AGREEMENT'
export const GET_AGREEMENT_ERROR = 'GET_AGREEMENT_ERROR'
export const GET_AGREEMENT_SUCCESS = 'GET_AGREEMENT_SUCCESS'
export const onGetAgreement = makeActionCreator(GET_AGREEMENT)
export const onGetAgreementError = makeActionCreator(GET_AGREEMENT_ERROR, 'payload')
export const onGetAgreementSuccess = makeActionCreator(GET_AGREEMENT_SUCCESS, 'payload')
export const onGetAgreementThunk =
  ({ callback, loading, ...payload }) =>
  async dispatch => {
    loading()
    dispatch(onGetAgreement(payload.id))
    try {
      const { data } = await getAgreement()
      const agreement = data.find(a => {
        return parseInt(a.idConvenioMarco) === parseInt(payload.id)
      })
      dispatch(
        onGetAgreementSuccess({
          agreement
        })
      )
      callback(agreement)
    } catch (error) {
      callback(null)
      return dispatch(onGetAgreementError(true))
    }
  }

export const GET_PRODUCTS = 'GET_PRODUCTS'
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR'
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS'
export const onGetProducts = makeActionCreator(GET_PRODUCTS)
export const onGetProductsError = makeActionCreator(GET_PRODUCTS_ERROR, 'payload')
export const onGetProductsSuccess = makeActionCreator(GET_PRODUCTS_SUCCESS, 'payload')
export const onGetProductsThunk =
  ({ callback, loading, payload }) =>
  async dispatch => {
    loading()
    dispatch(onGetProducts(payload))
    try {
      const { data } = await getProducts(payload)
      dispatch(
        onGetProductsSuccess({
          data
        })
      )
      callback(data)
    } catch (error) {
      callback(null)
      return dispatch(onGetProductsError(true))
    }
  }

export const GET_REQUESTS = 'GET_REQUESTS'
export const GET_REQUESTS_ERROR = 'GET_REQUESTS_ERROR'
export const GET_REQUESTS_SUCCESS = 'GET_REQUESTS_SUCCESS'
export const onGetRequests = makeActionCreator(GET_REQUESTS)
export const onGetRequestsError = makeActionCreator(GET_REQUESTS_ERROR, 'payload')
export const onGetRequestsSuccess = makeActionCreator(GET_REQUESTS_SUCCESS, 'payload')
export const onGetRequestsThunk =
  ({ callback, loading, payload }) =>
  async dispatch => {
    loading()
    dispatch(onGetRequests(payload))
    try {
      const { data } = await getRequests(payload)
      dispatch(
        onGetRequestsSuccess({
          data
        })
      )
      callback(data)
    } catch (error) {
      callback(null)
      return dispatch(onGetRequestsError(true))
    }
  }

export const GET_PRODUCTS_TYPE = 'GET_PRODUCTS_TYPE'
export const GET_PRODUCTS_TYPE_ERROR = 'GET_PRODUCTS_TYPE_ERROR'
export const GET_PRODUCTS_TYPE_SUCCESS = 'GET_PRODUCTS_TYPE_SUCCESS'
export const onGetProductsType = makeActionCreator(GET_PRODUCTS_TYPE)
export const onGetProductsTypeError = makeActionCreator(GET_PRODUCTS_TYPE_ERROR, 'payload')
export const onGetProductsTypeSuccess = makeActionCreator(GET_PRODUCTS_TYPE_SUCCESS, 'payload')
export const onGetProductsTypeThunk =
  ({ callback, id }) =>
  async dispatch => {
    dispatch(onGetProductsType(id))
    try {
      const { data } = await getProductsType({ id })
      const order = data.sort((firstObject, secondObject) => (firstObject.tpnombre > secondObject.tpnombre ? 1 : -1))
      dispatch(
        onGetProductsTypeSuccess({
          order
        })
      )
      callback(data)
    } catch (error) {
      callback(null)
      return dispatch(onGetProductsTypeError(true))
    }
  }

export const GET_RUT = 'GET_RUT'
export const GET_RUT_ERROR = 'GET_RUT_ERROR'
export const GET_RUT_SUCCESS = 'GET_RUT_SUCCESS'
export const onGetRut = makeActionCreator(GET_RUT)
export const onGetRutError = makeActionCreator(GET_RUT_ERROR, 'payload')
export const onGetRutSuccess = makeActionCreator(GET_RUT_SUCCESS, 'payload')
export const onGetRutThunk =
  ({ callback, providerId }) =>
  async dispatch => {
    dispatch(onGetRut(providerId))
    try {
      const { data } = await getRut({ providerId })
      dispatch(
        onGetRutSuccess({
          data
        })
      )
      callback(data)
    } catch (error) {
      callback(null)
      return dispatch(onGetRutError(true))
    }
  }

export const POST_CREATE_REQUEST = 'POST_CREATE_REQUEST'
export const POST_CREATE_REQUEST_ERROR = 'POST_CREATE_REQUEST_ERROR'
export const POST_CREATE_REQUEST_SUCCESS = 'POST_CREATE_REQUEST_SUCCESS'
export const onPostCreateRequest = makeActionCreator(POST_CREATE_REQUEST)
export const onPostCreateRequestError = makeActionCreator(POST_CREATE_REQUEST_ERROR, 'payload')
export const onPostCreateRequestSuccess = makeActionCreator(POST_CREATE_REQUEST_SUCCESS, 'payload')
export const onPostCreateRequestThunk =
  ({ successCallback, errorCallback, loading, payload }) =>
  async dispatch => {
    loading()
    dispatch(onPostCreateRequest())
    try {
      const { data } = await postCreateRequest(payload)
      if (data.length === 0) {
        throw customizeError({ originalError: data })
      }
      return batch(() => {
        successCallback(data)
        dispatch(onPostCreateRequestSuccess({ data: data.payload, success: data.success }))
      })
    } catch (error) {
      return batch(() => {
        dispatch(
          onPostCreateRequestError({
            errors: (error?.originalError?.response?.data?.errores || error?.originalError?.errores || []).map(
              item => item.descripcion
            )
          })
        )
        errorCallback()
      })
    }
  }

export const DOWNLOAD_RESQUEST = 'DOWNLOAD_RESQUEST'
export const DOWNLOAD_RESQUEST_ERROR = 'DOWNLOAD_RESQUEST_ERROR'
export const DOWNLOAD_RESQUEST_SUCCESS = 'DOWNLOAD_RESQUEST_SUCCESS'
export const onDownloadRequest = makeActionCreator(DOWNLOAD_RESQUEST)
export const onDownloadRequestError = makeActionCreator(DOWNLOAD_RESQUEST_ERROR, 'payload')
export const onDownloadRequestSuccess = makeActionCreator(DOWNLOAD_RESQUEST_SUCCESS, 'payload')
export const onDownloadRequestThunk =
  ({ callback, loading, payload }) =>
  async dispatch => {
    loading()
    dispatch(onDownloadRequest(payload))
    try {
      const { data } = await downloadRequests(payload)
      dispatch(
        onDownloadRequestSuccess({
          data
        })
      )
      callback(data)
    } catch (error) {
      callback(null)
      return dispatch(onDownloadRequestError(true))
    }
  }

export const GET_AGREEMENT_CONFIG = 'GET_AGREEMENT_CONFIG'
export const GET_AGREEMENT_CONFIG_ERROR = 'GET_AGREEMENT_CONFIG_ERROR'
export const GET_AGREEMENT_CONFIG_SUCCESS = 'GET_AGREEMENT_CONFIG_SUCCESS'
export const onGetAgreementConfig = makeActionCreator(GET_AGREEMENT_CONFIG)
export const onGetAgreementConfigError = makeActionCreator(false, 'payload')
export const onGetAgreementConfigSuccess = makeActionCreator(GET_AGREEMENT_CONFIG_SUCCESS, 'payload')
export const onGetAgreementConfigThunk =
  ({ callback, ...payload }) =>
  async dispatch => {
    dispatch(onGetAgreementConfig(payload.id))
    try {
      const { data } = await getAgreementConfig({ id: payload.id })
      dispatch(
        onGetAgreementConfigSuccess({
          data
        })
      )
      callback(data)
    } catch (error) {
      callback(error)
      return dispatch(onGetAgreementConfigError(true, error))
    }
  }

export const GET_ACTIVE_OFFERS = 'GET_ACTIVE_OFFERS'
export const GET_ACTIVE_OFFERS_ERROR = 'GET_ACTIVE_OFFERS_ERROR'
export const GET_ACTIVE_OFFERS_SUCCESS = 'GET_ACTIVE_OFFERS_SUCCESS'
export const onGetActiveOffer = makeActionCreator(GET_ACTIVE_OFFERS)
export const onGetActiveOfferError = makeActionCreator(false, 'payload')
export const onGetActiveOfferSuccess = makeActionCreator(GET_ACTIVE_OFFERS_SUCCESS, 'payload')
export const onGetActiveOfferThunk =
  ({ callback, payload }) =>
  async dispatch => {
    dispatch(onGetActiveOffer(payload))
    try {
      const { data } = await getActiveOffer(payload)
      dispatch(
        onGetActiveOfferSuccess({
          data
        })
      )
      callback(data)
    } catch (error) {
      callback(error)
      return dispatch(onGetActiveOfferError(true, error))
    }
  }
